// extracted by mini-css-extract-plugin
export default {"examples":"styles_examples__UcE9H","examplesInner":"styles_examplesInner__WJ1jQ","exampleImages":"styles_exampleImages__zsZ1n"};